import React from 'react'
import { Formik, Form } from 'formik'

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import SmsIcon from '@material-ui/icons/Sms'
import Button from '@material-ui/core/Button'
import TextField from '../../form/TextField'

const VerificationCodeInput = ({ classes, onSubmit }) => {
  return (
    <Formik onSubmit={onSubmit}>
      {({ dirty, isSubmitting }) => (
        <Form>
          <Grid
            container
            className={classes.wrapper}
            justify="center"
            alignItems="center">
            <Grid item md={3}>
              <Typography variant="display4" gutterBottom>
                Apólice
              </Typography>
              <Typography variant="headline" gutterBottom>
                Sua Apólice Mobile
              </Typography>
              <TextField
                fullWidth
                name="codeInput"
                type="text"
                placeholder="código de verificação"
                helperText="informe o código recebido via sms"
                margin="normal"
                InputProps={{
                  maxLength: 6,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SmsIcon />
                    </InputAdornment>
                  )
                }}
              />
              <div id="recaptcha-container" />
              <Button
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                type="submit"
                className={classes.button}
                disabled={!dirty || isSubmitting}>
                {!isSubmitting ? 'VERIFICAR' : 'Verificando ...'}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

const styles = theme => {
  console.log(theme)
  return {
    wrapper: {
      height: '100vh',
      width: '100vw',
      backgroundColor: theme.palette.secondary.main
    },
    button: {
      marginTop: 50
    }
  }
}

export default withStyles(styles)(VerificationCodeInput)
